export default "__VITE_ASSET__659aeb58__"